<template>
    <app-layout>
        <bax-header-banner :user="this.$store.state.auth.user" :headingMain="getHeadingLabel(orderViewType)"/>

        <main>
            <div class="bax-section bax-select-patient-wrap">
                <div class="container">
                    <vue-box class="d-md-flex align-items-md-center">
                        <h4>Search for orders</h4>
                        <div class="bax-form-wrapper ml-auto">
                            <form novalidate @submit.prevent="searchOrderList">
                                <div class="d-flex bax-search-element">
                                    <div class="bax-form-element">
                                        <input type="search" v-model="searchKeyword" placeholder="Search order reference #">
                                    </div>
                                    <div class="bax-form-elemnt">
                                        <button type="submit"><i class="icon-search"></i></button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </vue-box>
                    <br>
                    <vue-box class="panel-advanced">
                        <div class="bax-collapse"  @click="toggle">
                            <div class="bax-collapse-header d-md-flex align-items-center">
                                <h4>Advanced search</h4>
                                <span class="ml-auto d-block mt-3 mt-md-0">
                                    <i v-bind:class="[open === true ? 'icon-chevron-down' : 'icon-chevron-up']"></i>
                                </span>
                            </div>
                        </div>
                        <div class="bax-collapse-data" v-if="open">
                            <div class="bax-form-wrapper ml-auto">
                                <form novalidate @submit.prevent="searchOrderListAdvanced">
                                    <div class="bax-form-group" v-if="!isTPN()">
                                        <label>Patient first name</label>
                                        <input class="bax-input-control" type="text" placeholder="Patient first name" v-model="formData.patientFirstName">
                                    </div>
                                    <div class="bax-form-group" v-if="!isTPN()">
                                        <label>Patient last name</label>
                                        <input class="bax-input-control" type="text" placeholder="Patient last name" v-model="formData.patientLastName">
                                    </div>
                                    <div class="bax-form-group">
                                        <label>Order date</label>
                                        <date-entry v-model="formData.orderDate"></date-entry>
                                    </div>
                                    <div class="bax-form-group">
                                        <label>Delivery date (past 100 orders only)</label>
                                        <date-entry v-model="formData.deliveryDate"></date-entry>
                                    </div>
                                    <div class="bax-form-group">
                                        <label>Order reference number</label>
                                        <input class="bax-input-control" type="text" placeholder="Order number" v-model="formData.orderNumber">
                                    </div>
                                    <div class="bax-form-group d-flex justify-content-end">
                                        <button type="submit" class="mt-3 mt-md-0 bax-btn bax-btn bax-btn-blue ml-auto">
                                            Search
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </vue-box>
                    <div class="bax-search-title">
                        <div class="bax-form-wrapper">
                            <form>
                                <div class="bax-section-title d-flex align-items-center">
                                    <div class="
                                        bax-sort-block d-flex
                                        justify-content-md-between
                                        align-items-center
                                        ml-md-auto"
                                    >
                                        <label>Sort by</label>
                                        <select v-model="sortValue" required="required" @change="sortOrderByKey">
                                            <option value="date">Order Date</option>
                                            <option value="reference">Order Reference</option>
                                        </select>
                                        <div class="bax-sort-icon">
                                            <a href="#" @click.prevent="sortOrder" title="Sort by">
                                                <i v-if="sortBy === 'asc'" class="icon-arrow-up"></i>
                                                <i v-if="sortBy === 'desc'" class="icon-arrow-down"></i>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>

                    <div class="bax-filter">
                        <bax-order-list :orders="totalOrders" />
                    </div>

                    <div class="bax-cta-block d-md-flex">
                        <vue-button type="button" @click="back" color="link">Back</vue-button>
                        <vue-button
                            v-if="showLoadMore"
                            type="button"
                            color="primary"
                            class="bax-btn-load-more mx-auto mt-3 mt-md-0"
                            @click="loadMore"
                        >Load more</vue-button>
                    </div>
                </div>
            </div>
        </main>
    </app-layout>
</template>

<script>
import _ from 'lodash';
// import moment from 'moment';
import AppLayout from '@/components/layout/AppLayout.vue';
import OrderService from '@/core/api/order/order.service';
import BaxOrderList from '@/views/Order/BaxOrderList.vue';
import BaxHeaderBanner from '@/components/layout/BaxHeaderBanner.vue';
import DateEntry from '@/components/ui/DateEntry.vue';
import tpnMixin from '@/mixins/tpnMixin';

export default {
    name: 'ManageOrder',
    mixins: [tpnMixin],
    components: {
        AppLayout,
        DateEntry,
        BaxOrderList,
        BaxHeaderBanner,
    },
    data() {
        return {
            hospitalName: '',
            sortValue: 'date',
            sortBy: 'asc',
            originalRecords: [],
            totalOrders: [],
            searchKeyword: '',
            formData: {
                patientFirstName: '',
                patientLastName: '',
                orderDate: '',
                deliveryDate: '',
                orderNumber: '',
                type: '',
            },
            open: false,
            // load more
            perPage: 10,
            showLoadMore: false,
            orderViewType: '',
        };
    },
    created() {
        this.hospitalName = this.$store.state.auth.user.hospitalName;
        const { q, order, isAdvanced } = this.$route.query;
        if (isAdvanced) this.open = true;

        this.orderViewType = order;
        if (q !== '' && typeof q !== 'undefined') {
            this.searchKeyword = q;
            this.searchOrder();
        } else if (order !== '' && typeof order !== 'undefined') {
            this.searchOrderByType(order);
        }
    },
    methods: {
        toggle() {
            if (this.open) {
                this.open = false;
            } else {
                this.open = true;
            }
        },
        goToManageOrder(order) {
            if (order.type !== 'draft') {
              const orderPage = (this.isTPN() ? 'manageSingleOrderTPN' : 'manageSingleOrder');
                this.$router.push({
                    name: orderPage,
                    params: {
                        orderId: order.groupOrderID,
                    },
                    query: {
                        from: this.$route.name,
                        order: this.$route.query.order,
                        search: this.searchKeyword,
                    },
                });
            } else {
              const orderPage = (this.isTPN() ? 'reviewCompleteTPN' : 'reviewComplete');
                this.$router.push({
                    name: orderPage,
                    params: {
                        orderId: order.orderReference,
                    },
                });
            }
        },
        loadMore() {
            this.perPage += 10;
            this.calculateLoadMoreOptions();
        },
        calculateLoadMoreOptions() {
            this.totalOrders = this.originalRecords.slice(0, this.perPage);

            const total = this.originalRecords.length;
            const shownInPage = this.totalOrders.length;

            if (shownInPage < total) {
                this.showLoadMore = true;
            } else {
                this.showLoadMore = false;
            }
        },
        back() {
          if (this.isTPN()) {
            this.$router.push({ name: 'homeTPN' });
          } else {
            this.$router.push({ name: 'home' });
          }
        },
        searchOrder() {
          const criteria = {};
          criteria.keyword = this.searchKeyword;
          criteria.type = this.isTPN() ? 'tpn' : 'compounding';
            OrderService.searchOrder(criteria)
                .then((res) => {
                    const { data } = res;

                    this.originalRecords = _.values(data);
                    this.sortOrder();

                    this.calculateLoadMoreOptions();
                });
        },
        searchOrderAdvanced() {
          this.formData.type = this.isTPN() ? 'tpn' : 'compounding';
            const criteria = this.formData;
            OrderService.searchOrderAdvanced(criteria)
                .then((res) => {
                    const { data } = res;

                    this.originalRecords = _.values(data);
                    this.sortOrder();

                    this.calculateLoadMoreOptions();
                });
        },
        searchOrderList() {
            if (this.searchKeyword === '' || typeof this.searchKeyword === 'undefined') {
                if (this.$route.query.order) {
                    this.$router.replace({
                        query: {
                            order: this.$route.query.order,
                        },
                    });
                }
                return;
            }

            const query = {};

            query.q = this.searchKeyword;

            if (this.$route.query.order) {
                query.order = this.$route.query.order;
            }

            this.$router.replace({
                query,
            });

            this.searchOrder();
        },
        searchOrderListAdvanced() {
            const query = {};

            query.patientFirstName = this.formData.patientFirstName;
            query.patientLastName = this.formData.patientLastName;
            query.orderDate = this.formData.orderDate;
            query.deliveryDate = this.formData.deliveryDate;
            query.orderNumber = this.formData.orderNumber;

            this.$router.replace({
                query,
            });

            this.searchOrderAdvanced();
        },
        sortOrder() {
            if (this.sortBy === 'asc') {
                this.sortBy = 'desc';
            } else {
                this.sortBy = 'asc';
            }

            if (this.sortValue === 'date') {
                this.sortOrderByDate();
            } else {
                this.originalRecords = _.orderBy(this.originalRecords, 'orderReference', this.sortBy);
            }

            this.calculateLoadMoreOptions();
        },
        sortOrderByKey() {
            if (this.sortValue === 'date') {
                this.sortOrderByDate();
            } else {
                this.originalRecords = _.orderBy(this.originalRecords, 'orderReference', this.sortBy);
            }

            this.calculateLoadMoreOptions();
        },
        searchOrderByType(type) {
          let newType = type;
          if (this.isTPN()) {
            newType = type + 'TPN';
          }

            OrderService.searchOrderByType(newType)
                .then((res) => {
                    const { data } = res;

                    this.originalRecords = _.values(data);
                    this.sortOrder();

                    this.calculateLoadMoreOptions();
                });
        },
        sortOrderByDate() {
            let info;

            if (this.sortBy === 'desc') {
                info = this.originalRecords.sort((a, b) => {
                    const aa = a.orderDate.split('/').reverse().join();
                    const bb = b.orderDate.split('/').reverse().join();
                    // eslint-disable-next-line
                    return aa < bb ? 1 : (aa > bb ? -1 : 0);
                });
            } else {
                info = this.originalRecords.sort((a, b) => {
                    const aa = a.orderDate.split('/').reverse().join();
                    const bb = b.orderDate.split('/').reverse().join();
                    // eslint-disable-next-line
                    return aa < bb ? -1 : (aa > bb ? 1 : 0);
                });
            }

            this.originalRecords = info;
        },
        getOrderRefrenceVal(order) {
            if (order.type === 'draft') {
                return order.orderRefView;
            }

            return order.orderReference;
        },
        getHeadingLabel(orderViewType) {
            switch (orderViewType) {
                case 'recent':
                    return 'Manage Recent Orders';
                case 'onHold':
                    return 'Manage On Hold Orders';
                case 'draft':
                    return 'Manage Draft Orders';
                default:
                    return '';
            }
        },
    },
};
</script>

<h1 class="d-flex align-items-center" v-if="orderViewType === 'recent'">Manage Recent Orders</h1>
<h1 class="d-flex align-items-center" v-if="orderViewType === 'onHold'">Manage On Hold Orders</h1>
<h1 class="d-flex align-items-center" v-if="orderViewType === 'draft'">Manage Draft Orders</h1>


<style scoped lang="scss">
.bax-sort-block {
    select {
        width: 180px;
    }
}
.bax-collapse-header{
    cursor: pointer;
}
.panel-advanced{
    padding: 0;
    .bax-collapse{
        padding: 1.875rem 1.5625rem;
    }
    .bax-collapse-data{
        padding: 1.875rem 1.5625rem;
        padding-top: 0;
    }
}
</style>
